///<reference path="../../../../egifts/egifts.model.ts"/>

module Meevo.Plugins.AlertsManager {
    import DeliveryMethodEnum = Meevo.Plugins.Egifts.DeliveryMethodEnum;
    import IAlertJSON = Meevo.Model.IAlertJSON;

    interface IDeliveryModel {
        email: boolean;
        mail: boolean;
        pickup: boolean;
    }

    interface IGiftCardIsSoldAlertJson extends IAlertJSON {
        deliveryMethods: DeliveryMethodEnum[];
    }

    class MeevoGiftCardIsSoldConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService',
            '$translate'
        ];

        public params: IParams;
        public data: ISingleMoverData;

        public deliveryModel: IDeliveryModel;

        get dataForReview() {
            let arr: string[] = [];

            if (this.deliveryModel.email) arr.push(this.$translate.instant('LABEL_EMAIL_CHECKBOX'));
            if (this.deliveryModel.mail) arr.push(this.$translate.instant('LABEL_MAIL'));
            if (this.deliveryModel.pickup) arr.push(this.$translate.instant('LABEL_PICK_UP'));

            return arr;
        }

        get alertConfiguration() {
            let arr: DeliveryMethodEnum[] = [];

            if (this.deliveryModel.mail) arr.push(DeliveryMethodEnum.Mail);
            if (this.deliveryModel.email) arr.push(DeliveryMethodEnum.EMail);
            if (this.deliveryModel.pickup) arr.push(DeliveryMethodEnum.StorePickup);

            return {
                deliveryMethods: arr
            }
        }

        constructor(protected alertsManagerService: IAlertsManagerService,
                    private $translate: angular.translate.ITranslateService) {
            super(alertsManagerService);

            this.deliveryModel = {
                email: false,
                mail: false,
                pickup: false,
            }
        }

        onEdit(alertJSON: IGiftCardIsSoldAlertJson): void {
            this.deliveryModel = {
                email: alertJSON.deliveryMethods.indexOf(DeliveryMethodEnum.EMail) !== -1,
                mail: alertJSON.deliveryMethods.indexOf(DeliveryMethodEnum.Mail) !== -1,
                pickup: alertJSON.deliveryMethods.indexOf(DeliveryMethodEnum.StorePickup) !== -1,
            }
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoGiftCardIsSoldConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/giftcard-is-sold-config/giftcard-is-sold-config.component.html',
            controller: MeevoGiftCardIsSoldConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        });
}
